import {
  facilitiesQuery,
  useDeleteFacilityMutation,
} from "@common/api/facilities"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/delete",
)({
  component: DeleteFacilityDialog,
})

function DeleteFacilityDialog(): React.ReactElement | null {
  const { facilityId } = Route.useParams()
  const { data } = useSuspenseQuery(facilitiesQuery())
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const deleteMutation = useDeleteFacilityMutation()
  const facility = data.data.find((item) => item.id === facilityId)

  if (!facility) {
    return null
  }

  const close = () =>
    navigate({
      to: "/settings/workspace/facilities/$facilityId",
      params: { facilityId },
      search: true,
    })

  const confirm = () =>
    deleteMutation.mutate(
      { facility_id: facilityId },
      {
        onSuccess: () => {
          showToast("Archived", `${facility.name} archived.`, "success")
          navigate({ to: "/settings/workspace/facilities", search: true })
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Archive ${facility.name}?`}
      description="This archives the facility and all its locations. Restoring the facility brings them back."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={deleteMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
